import {
  WSDrawer,
  WSElement,
  WSLayout,
  WSScreen
} from "@wingspanhq/fe-component-library";
import React from "react";

export type DrawerLayoutProps = {
  title: string;
  onBack: () => void;
};

export const DrawerLayout: React.FC<DrawerLayoutProps> = ({
  title,
  onBack,
  children
}) => {
  return (
    <>
      <WSScreen.Mobile>
        <WSLayout title={title} onBack={onBack} line>
          <WSElement p="M">{children}</WSElement>
        </WSLayout>
      </WSScreen.Mobile>
      <WSScreen.TabletAndDesktop>
        <WSDrawer onClose={onBack} size="S" noCloseIcon>
          <WSLayout title={title} onBack={onBack} line smallHeader>
            <WSElement p="M">{children}</WSElement>
          </WSLayout>
        </WSDrawer>
      </WSScreen.TabletAndDesktop>
    </>
  );
};
